/**
 * MongoDB ObjectId as a 24-character hex string (what the chat API uses for
 * `conversation_messages._id` and SSE `done.message_id`).
 * Not UUIDs and not temporary client ids like `(Date.now()+1).toString()`.
 */
export function isMongoObjectIdString(value) {
  return typeof value === 'string' && /^[a-fA-F0-9]{24}$/.test(value);
}
